import { createReducer, on } from '@ngrx/store';
import { EndUser } from 'src/app/core/proto';
import { actionEndUsersListGet, actionEndUsersListGetSuccess } from 'src/app/core/store/consumers/consumers.actions';

export interface ConsumersState {
  brandId?: string;
  endUserIds?: string[];
  endUsers?: EndUser[];
  isLoadingConsumer?: boolean;
  isLoadingConsumerList?: boolean;
}

const initialState: ConsumersState = {
  brandId: undefined,
  endUserIds: [],
  endUsers: [],
  isLoadingConsumer: true,
  isLoadingConsumerList: true,
};

export const consumerReducer = createReducer(
  initialState,
  on(actionEndUsersListGet, (state, action) => {
    return {
      ...state,
      brandId: action.body.brandId || undefined,
      endUserIds: action.body.endUserIds || [],
      isLoadingConsumerList: true,
    };
  }),
  on(actionEndUsersListGetSuccess, (state, action) => {
    return {
      ...state,
      endUsers: action.payload.endUsers || [],
      isLoadingConsumerList: false,
    };
  }),
);
